import { render, staticRenderFns } from "./ListingModal.vue?vue&type=template&id=b70cb6fe&scoped=true&"
import script from "./ListingModal.vue?vue&type=script&lang=js&"
export * from "./ListingModal.vue?vue&type=script&lang=js&"
import style0 from "./ListingModal.vue?vue&type=style&index=0&id=b70cb6fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70cb6fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,Modal: require('/app/appsumo/nuxt/components/common/Modal.vue').default})
